import React from "react";
import {Card, Col, Form, Input, Row} from "antd";
import {GUTTER_MD, MARGIN_MD, SPAN_HALF, SPAN_ONE_THIRD, SPAN_TWO_THIRDS} from "../../../styles/constants";
import {compose} from "redux";
import {translate} from "react-i18next";
import {isIDValidWithHelp} from "../../../utils/artefactValidators";

const cardLayout = customStyle => ({
    type: 'inner',
    style: {
        marginBottom: MARGIN_MD,
        ...(customStyle || {})
    }
});

const formItemLayout = {
    labelCol: {span: SPAN_ONE_THIRD},
    wrapperCol: {span: SPAN_TWO_THIRDS}
};

const DataflowHeaderCard = ({t, title, form, type, disabled, receiverDisabled, style}) => {
    return (
        <Card title={title} {...cardLayout(style)}>
            <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_HALF}>
                    <Form.Item
                        className={type === "sender" ? "form-item-required" : null}
                        label={t('data.dataflow.header.organisationId.label')}
                        validateStatus={type === "sender" ? form.getFieldValue(`${type}.organisationId`) && isIDValidWithHelp(t, form.getFieldValue(`${type}.organisationId`)).help ? "warning" : null: null}
                        help={type === "sender" ? form.getFieldValue(`${type}.organisationId`) && isIDValidWithHelp(t, form.getFieldValue(`${type}.organisationId`)).help : null}
                        {...formItemLayout}
                    >
                        {form.getFieldDecorator(`${type}.organisationId`, {
                            getValueFromEvent: e => e.target.value.toUpperCase()
                        })(
                            <Input
                                title={form.getFieldValue(`${type}.organisationId`)}
                                disabled={disabled}
                                style={{textTransform: "uppercase"}}
                            />
                        )}
                    </Form.Item>
                </Col>
                <Col span={SPAN_HALF}>
                    <Form.Item
                        label={t('data.dataflow.header.organisationName.label')} {...formItemLayout}>
                        {form.getFieldDecorator(`${type}.organisationName`)(
                            <Input title={form.getFieldValue(`${type}.organisationName`)} disabled={type === "receiver" ? receiverDisabled : disabled}/>
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_HALF}>
                    <Form.Item
                        label={t('data.dataflow.header.contactName.label')} {...formItemLayout}>
                        {form.getFieldDecorator(`${type}.contactName`)(
                            <Input title={form.getFieldValue(`${type}.contactName`)} disabled={type === "receiver" ? receiverDisabled : disabled}/>
                        )}
                    </Form.Item>
                </Col>
                <Col span={SPAN_HALF}>
                    <Form.Item
                        label={t('data.dataflow.header.contactEmail.label')} {...formItemLayout}>
                        {form.getFieldDecorator(`${type}.contactEmail`)(
                            <Input title={form.getFieldValue(`${type}.contactEmail`)} disabled={type === "receiver" ? receiverDisabled : disabled}/>
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_HALF}>
                    <Form.Item
                        label={t('data.dataflow.header.contactDepartment.label')} {...formItemLayout}>
                        {form.getFieldDecorator(`${type}.contactDepartment`)(
                            <Input title={form.getFieldValue(`${type}.contactDepartment`)} disabled={type === "receiver" ? receiverDisabled : disabled}/>
                        )}
                    </Form.Item>
                </Col>
                <Col span={SPAN_HALF}>
                    <Form.Item
                        label={t('data.dataflow.header.contactRole.label')} {...formItemLayout}>
                        {form.getFieldDecorator(`${type}.contactRole`)(
                            <Input title={form.getFieldValue(`${type}.contactRole`)} disabled={type === "receiver" ? receiverDisabled : disabled}/>
                        )}
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    )
}

export default compose(
    translate(),
)(DataflowHeaderCard);
